// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__hHVAj","additionalInfo":"AgreementModal_additionalInfo__3BVfN"};